import axios from "axios";
import {
  TIIVII_API_GET_IN_USE_GRAPHICSET,
  TIIVII_API_GET_LOCAL_RECORDINGS,
  TIIVII_API_OPERATIONS,
  TIIVII_API_UPDATE_CONTRACT_TEMPLATE,
  TIIVII_API_DELETE_SECOND_COACH,
  TIIVII_API_DELETE_OCURRENCE_SOURCE,
  TIIVII_API_POST_OCURRENCE_SOURCE,
  TIIVII_API_DELETE_PARTNER_FOR_CUSTOMER,
  TIIVII_API_NEW_SHIELD_EVENT,
  TIIVII_GET_CONTRACT_INFO_OTT,
  TIIVII_GET_RECORDING_DOWNLOAD_URL,
  TIIVII_API_GET_RECORDING_CLIPS,
  TIIVII_API_GET_CONTRACTS,
  TIIVII_API_GET_SUBDEPLOYMENTS,
  TIIVII_API_GET_ROOM_TEMPLATES,
  TIIVII_API_GET_ROOM_TEMPLATE,
  TIIVII_API_GET_EVENT_TYPE,
  TIIVII_API_GET_CONTRACT,
  TIIVII_API_EVENTS,
  TIIVII_API_GET_SCOREBOARD_TYPES,
  TIIVII_API_GET_SCOREBOARD_TEMPLATES,
  TIIVII_API_ASSETS_BY_CUSTOMER,
  TIIVII_API_ASSET_CATEGORIES,
  TIIVII_API_GET_OCCURRENCE_SOURCES,
  TIIVII_API_GET_EVENT,
  TIIVII_API_PATCH_EVENT,
  TIIVII_API_DELETE_EVENT_GRAPHIC_SET,
  TIIVII_API_MANAGE_COMPONENT,
  TIIVII_API_POST_GLOBAL_ASSET,
  TIIVII_API_GET_USER_CUSTOMERS,
  TIIVII_API_GET_USER_CONTRACTS,
  TIIVII_API_DELETE_EVENT,
} from "../utils/constants";
import { keycloak } from "../config/keycloak";
import { apiPaginationConverter } from "../utils/api-pagination";
import { LARGE_SELECT_LIMIT } from "../components/select/utils/select-constants";

let isRedirectingToLogin = false;

const redirectToLogin = () => {
  if (!isRedirectingToLogin) {
    isRedirectingToLogin = true;
    keycloak.login();
  }
};

// Ante un 401 (access token de Keycloak caducado), refresca con el refresh token y reintenta
// la petición original una única vez; si el refresh token también ha caducado, vuelve a login.
axios.interceptors.response.use(
  response => response,
  async error => {
    const { config, response } = error;

    if (response?.status !== 401 || !config || config._retriedAfterTokenRefresh) {
      return Promise.reject(error);
    }
    config._retriedAfterTokenRefresh = true;

    try {
      await keycloak.updateToken(-1);
      config.headers.Authorization = `Bearer ${keycloak.token}`;
      return axios(config);
    } catch (refreshError) {
      redirectToLogin();
      return Promise.reject(refreshError);
    }
  },
);

export const createOperationService = (params, thenCallback) => {
  const options = getOptions({});
  axios
    .post(
      buildUrl(TIIVII_API_OPERATIONS, {
        streamsource_id: params.streamsourceId,
      }),
      { action: params.action, params: { recording_id: params.recording_id } },
      options,
    )
    .then(response => {
      thenCallback(response.data);
    });
};

export const downloadRecordingService = (params, thenCallback, errorCallback) => {
  axios
    .post(
      buildUrl(TIIVII_API_OPERATIONS, {
        streamsource_id: params.streamsourceId,
      }),
      {
        action: params.action,
        params: { recording_id: params.recording_id },
      },
      getOptions({ responseType: "blob" }),
    )
    .then(response => {
      const url = window.URL.createObjectURL(response.data);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", params.recording_id + ".mkv");
      document.body.appendChild(link);
      link.click();
      thenCallback(null);
    })
    .catch(error => {
      if (errorCallback) {
        errorCallback(error);
      } else {
        thenCallback(null);
      }
    });
};

export const getInUseGraphicSet = (params, thenCallback) => {
  const options = getOptions({});
  const url = buildUrl(TIIVII_API_GET_IN_USE_GRAPHICSET, {
    customer_id: params.customer_id,
    graphicset_id: params.graphicset_id,
  });

  axios.get(url, options).then(response => {
    thenCallback(response.data);
  });
};

export const getLocalRecordingsService = (params, callback) => {
  const options = getOptions({});
  const url = buildUrl(TIIVII_API_GET_LOCAL_RECORDINGS, { event_id: params.eventId });

  axios.get(url, options).then(callback);
};

export const updateTemplateFile = (params, thenCallback, errorCallback) => {
  const options = getOptions({ headers: { "Content-Type": "application/x-www-form-urlencoded" } });
  const url = buildUrl(TIIVII_API_UPDATE_CONTRACT_TEMPLATE, { contract_id: params.contractId, room_id: params.roomId });
  const bodyFormData = new FormData();
  bodyFormData.append("full_text", params.body.file);
  axios
    .put(url, bodyFormData, options)
    .then(response => {
      thenCallback(response.data);
    })
    .catch(e => {
      errorCallback(e);
    });
};

export const deleteSecondCoachStreamSource = (params, thenCallback) => {
  const options = getOptions({});
  axios
    .delete(
      buildUrl(TIIVII_API_DELETE_SECOND_COACH, {
        streamsource_id: params.streamsourceId,
      }),
      options,
    )
    .then(response => {
      thenCallback(response);
    });
};

export const getOcurrenceSource = (params, thenCallback) => {
  const options = getOptions({});
  const url = buildUrl(TIIVII_API_POST_OCURRENCE_SOURCE, {
    contract_id: params.contract_id,
    event_type_id: params.event_type_id,
  });
  axios
    .get(url, options)
    .then(response => {
      thenCallback(response);
    })
    .catch(error => {
      thenCallback(error);
    });
};

export const postOcurrenceSource = (body, params, thenCallback) => {
  const options = getOptionsUrlEncoded({});
  const url = buildUrl(TIIVII_API_POST_OCURRENCE_SOURCE, {
    contract_id: params.contract_id,
    event_type_id: params.event_type_id,
  });
  const bodySend = `occurrence_source=${body}`;
  axios.post(url, bodySend, options).then(response => {
    thenCallback(response.data);
  });
};

export const deleteOcurrenceSource = (params, thenCallback) => {
  const options = getOptions({});
  const url = buildUrl(TIIVII_API_DELETE_OCURRENCE_SOURCE, {
    contract_id: params.contract_id,
    event_type_id: params.event_type_id,
    occurrence_source_name: params.occurrence_source_name,
  });
  axios.delete(url, options).then(response => {
    thenCallback(response.data);
  });
};

export const getContractsService = (thenCallback, limit = 0, contractsWithoutCustomer = undefined) => {
  const options = getOptions({});

  let url = TIIVII_API_GET_CONTRACTS;

  const queryParams = buildQueryParams({
    limit: limit ?? LARGE_SELECT_LIMIT,
    contracts_without_customer: contractsWithoutCustomer,
  });

  url = `${url}?${queryParams}`;

  axios.get(url, options).then(response => thenCallback(response.data));
};

export const getUserCustomers = (variables, callback = void 0, errorCallback = void 0) => {
  const { page, perPage, limit, username } = variables;

  const options = getOptions({});
  let url = buildUrl(TIIVII_API_GET_USER_CUSTOMERS, { username });

  const queryParams = buildQueryParams({
    limit: Number.isInteger(page) ? perPage : limit ?? LARGE_SELECT_LIMIT,
    offset: Number.isInteger(page) ? apiPaginationConverter(page, perPage).offset : undefined,
  });

  url = `${url}?${queryParams}`;

  axios
    .get(url, options)
    .then(response => {
      if (!!callback) callback(response);
    })
    .catch(error => errorCallback(error));
};

export const getUserContracts = (variables, callback = void 0, errorCallback = void 0) => {
  if (!variables || typeof variables !== "object") {
    throw new Error("Invalid input: variables must be an object");
  }
  const { page, perPage, limit, username, contractName, deploymentId } = variables;

  const options = getOptions({});
  let url = buildUrl(TIIVII_API_GET_USER_CONTRACTS, { username });

  const queryParams = buildQueryParams({
    limit: Number.isInteger(page) ? perPage : limit ?? LARGE_SELECT_LIMIT,
    offset: Number.isInteger(page) ? apiPaginationConverter(page, perPage).offset : undefined,
    contract_name: !!contractName ? contractName : undefined,
    deployment_id: !!deploymentId ? deploymentId : undefined,
  });

  url = `${url}?${queryParams}`;

  const fetchUserContracts = async () => {
    try {
      const response = await axios.get(url, options);
      if (!!callback) callback(response);
    } catch (error) {
      if (!!errorCallback) errorCallback(error);
    }
  };

  void fetchUserContracts();
};

export const getContractSubDeploymentsFromContractId = (params, thenCallback) => {
  const options = getOptions({});
  axios
    .get(
      buildUrl(TIIVII_API_GET_SUBDEPLOYMENTS, {
        contract_id: params.contract_id,
      }),
      options,
    )
    .then(response => {
      thenCallback(response.data);
    });
};

export const deletePartnerForCustomer = (params, thenCallback) => {
  const options = getOptions({});
  axios
    .delete(
      buildUrl(TIIVII_API_DELETE_PARTNER_FOR_CUSTOMER, {
        customer_id: params.customerId,
        partner_id: params.partnerId,
      }),
      options,
    )
    .then(response => {
      thenCallback(response);
    });
};

// base64 encode to file -- nacho
export const dataURLtoFile = (dataurl, filename) => {
  let arr = dataurl.split(","),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], filename, { type: mime });
};

export const updateNewShieldEventFile = (
  params,
  thenCallback,
  errorCallback = void 0,
  isGlobalAsset = false,
  type = "image",
) => {
  const options = getOptions({ headers: { "Content-Type": "application/x-www-form-urlencoded" } });
  const url = isGlobalAsset
    ? TIIVII_API_POST_GLOBAL_ASSET
    : buildUrl(TIIVII_API_NEW_SHIELD_EVENT, { customer_id: params.customerId });

  const bodyFormData = new FormData();

  if (type === "image") {
    const image = dataURLtoFile(params.body.file.image, params.body.file.codename);
    bodyFormData.append("image", image);
  } else {
    bodyFormData.append("image", params.body.file.image);
  }

  bodyFormData.append("codename", params.body.file.codename);
  bodyFormData.append("asset_categories_ids", params.body.file.categoryIds);
  bodyFormData.append("description", params.body.file.description);

  axios
    .post(url, bodyFormData, options)
    .then(response => {
      thenCallback(response.data);
    })
    .catch(error => {
      if (!!errorCallback) {
        errorCallback(error);
      }
    });
};

export const getContractHasTiiviiOtt = (params, thenCallback) => {
  const options = getOptions({});
  const url = buildUrl(TIIVII_GET_CONTRACT_INFO_OTT, { contract_id: params.contractId });

  axios.get(url, options).then(response => {
    thenCallback(response.data);
  });
};

export const getDownloadUrlService = (recordingId, thenCallback, catchCallback) => {
  const options = getOptions({});
  const url = buildUrl(TIIVII_GET_RECORDING_DOWNLOAD_URL, { recording_id: recordingId });

  axios
    .get(url, options)
    .then(response => {
      thenCallback(response.data);
    })
    .catch(error => catchCallback(error));
};

export const getRecordingClipsService = (params, callback, catchCallback) => {
  const options = getOptions({});

  const { eventId, page, perPage } = params;

  let url = `${TIIVII_API_GET_RECORDING_CLIPS}?event_id=${eventId}`;

  if (page) {
    const { limit, offset } = apiPaginationConverter(page, perPage);

    if (limit) {
      url = url + `&limit=${limit}`;
    }
    if (offset) {
      url = url + `&offset=${offset}`;
    }
  }

  axios
    .get(url, options)
    .then(callback)
    .catch(error => {
      catchCallback(error);
    });
};

export const getEventService = async (event_id, callback, errorCallback) => {
  const options = getOptions({});
  const url = buildUrl(TIIVII_API_GET_EVENT, { event_id });

  try {
    const response = await axios.get(url, options);
    callback(response.data);
  } catch (error) {
    errorCallback(error);
  }
};

export const getRoomTemplatesService = (contract_id, test = true, callback, errorCallback) => {
  const options = getOptions({});

  let url = `${buildUrl(TIIVII_API_GET_ROOM_TEMPLATES, { contract_id })}`;

  if (!test) {
    url = `${url}?test=${test}`;
  }

  axios
    .get(url, options)
    .then(response => callback(response.data))
    .catch(error => errorCallback(error));
};

export const getRoomTemplateService = (contract_id, room_id, callback, errorCallback) => {
  const options = getOptions({});
  const url = buildUrl(TIIVII_API_GET_ROOM_TEMPLATE, { contract_id, room_id });

  axios
    .get(url, options)
    .then(response => callback(response.data))
    .catch(error => errorCallback(error));
};

export const getEventTypesService = (event_type_id, callback) => {
  const options = getOptions({});
  const url = buildUrl(TIIVII_API_GET_EVENT_TYPE, { event_type_id });

  axios.get(url, options).then(response => callback(response.data));
};

export const getContractService = (contract_id, callback) => {
  const options = getOptions({});
  const url = buildUrl(TIIVII_API_GET_CONTRACT, { contract_id });

  axios.get(url, options).then(response => callback(response.data));
};

// El backend necesita room_template_id para saber qué marcadores están disponibles:
// sin él la respuesta no es correcta, así que no se lanza la petición.
export const getScoreboardTypesService = (contract_id, event_type_id, room_template_id, callback) => {
  if (!contract_id || !event_type_id || !room_template_id) {
    console.error("getScoreboardTypesService: contract_id, event_type_id y room_template_id son obligatorios");
    return;
  }

  const options = getOptions({});
  const queryParams = buildQueryParams({ room_template_id });
  const url = `${buildUrl(TIIVII_API_GET_SCOREBOARD_TYPES, { contract_id, event_type_id })}?${queryParams}`;

  axios.get(url, options).then(response => callback(response.data));
};

export const getScoreboardTemplatesService = (contract_id, event_type_id, callback) => {
  const options = getOptions({});
  const url = buildUrl(TIIVII_API_GET_SCOREBOARD_TEMPLATES, { contract_id, event_type_id });

  axios.get(url, options).then(response => callback(response.data));
};

export const getAssetCategoriesService = callback => {
  const options = getOptions({});
  axios.get(TIIVII_API_ASSET_CATEGORIES, options).then(response => callback(response.data));
};

export const getAssetsByCustomer = (customer_id, params, callback) => {
  const options = getOptions({});
  let url = buildUrl(TIIVII_API_ASSETS_BY_CUSTOMER, { customer_id });

  if (!!Object.keys(params)?.length) {
    url +=
      "?" +
      Object.keys(params)
        .map(key => key + "=" + params[key])
        .join("&");
  }

  axios.get(url, options).then(response => callback(response.data));
};

export const getOccurrenceSources = (params, callback) => {
  const options = getOptions({});
  const url = buildUrl(TIIVII_API_GET_OCCURRENCE_SOURCES, {
    contract_id: params.contractId,
    event_type_id: params.eventTypeId,
  });

  axios.get(url, options).then(response => callback(response.data));
};

export const createEventService = (body, callback, errorCallback) => {
  const options = getOptions({});

  axios
    .post(TIIVII_API_EVENTS, body, options)
    .then(response => {
      callback(response.data);
    })
    .catch(e => errorCallback(e));
};

export const updateEventService = (event_id, body, callback, errorCallback) => {
  const options = getOptions({});
  const url = buildUrl(TIIVII_API_PATCH_EVENT, { event_id });

  axios
    .patch(url, body, options)
    .then(() => {
      callback();
    })
    .catch(e => errorCallback(e));
};

export const manageComponentService = (event_id, component_name, action, callback, errorCallback) => {
  const options = getOptions({});
  const url = `${buildUrl(TIIVII_API_MANAGE_COMPONENT, { event_id })}?${buildQueryParams({ component_name, action })}`;

  axios
    .post(url, null, options)
    .then(() => callback())
    .catch(error => errorCallback(error));
};

export const deleteEventService = (event_id, username, callback, errorCallback) => {
  const options = getOptions({});
  const url = `${buildUrl(TIIVII_API_DELETE_EVENT, { event_id })}?${buildQueryParams({ username })}`;

  axios
    .delete(url, options)
    .then(() => callback())
    .catch(error => errorCallback(error));
};

// Adaptador para que la llamada REST de borrado de evento encaje con el mismo contrato
// que ya esperan `ActionWithModal`/`DeleteActionWithModal`: una función (options) => Promise
// que resuelve con { data: { [elementNameInResult]: <valor truthy> } } en éxito.
export const deleteEventAction = ({ variables: { eventId, username } }) =>
  new Promise((resolve, reject) =>
    deleteEventService(eventId, username, () => resolve({ data: { deleteEvent: true } }), reject),
  );

export const deleteEventGraphicSetService = (event_id, callback, errorCallback) => {
  const options = getOptions({});
  const url = buildUrl(TIIVII_API_DELETE_EVENT_GRAPHIC_SET, { event_id });

  axios
    .delete(url, options)
    .then(() => {
      callback();
    })
    .catch(e => errorCallback(e));
};

/**
 * Dado un valor para url = 'https://bert.tiivii.com/api/studio/:id/event/:event_id' y un valor para variables = {
 *   id: "un_id", event_id: "un_event_id"}, devolvería https://bert.tiivii.com/api/studio/un_id/event/un_event_id
 * @param url Url con placeholders
 * @param variables objeto con las substituciones a realizar
 * @returns {string} con la url generada a partir de las substituciones.
 */
export const buildUrl = (url, variables) =>
  url.replace(/:(\w+)/g, (match, p1) => (p1 in variables ? variables[p1] : match));

export const getOptions = (config = {}, withAuthentication = true) => {
  const configObject = {
    headers: {
      "Content-Type": "application/json",
      ...config.headers,
    },
    ...config,
  };
  if (withAuthentication) {
    configObject.headers.Authorization = `Bearer ${!!keycloak && !!keycloak.token ? keycloak.token : undefined}`;
  }

  return configObject;
};

const getOptionsUrlEncoded = (config = {}, withAuthentication = true) => {
  const configObject = {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      ...config.headers,
    },
    ...config,
  };
  if (withAuthentication) {
    configObject.headers.Authorization = `Bearer ${!!keycloak && !!keycloak.token ? keycloak.token : undefined}`;
  }

  return configObject;
};

export const buildQueryParams = paramsObj => {
  const params = new URLSearchParams();
  Object.entries(paramsObj).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      params.append(key, value);
    }
  });
  return params.toString();
};
